<template>
  <div class="bgAdminRecruiter">
    <div class="application_layout">
      <header
        id="header"
        class="u-header--starter"
      >
        <nav
          id="logoAndNav"
          class="navbar navbar-dark lex-nowrap bg_menu p-0 bg-white"
          style="border-bottom: 1px solid #937ed0"
        >
          <inertia-link
            href="/recruiters/dashboard"
            class="m-3"
          >
            <img
              src="/images/Jovool_logo.png"
              width="120px"
            />
          </inertia-link>

          <div
            class="input-group input-group-xs input-group-borderless d-md-flex mr-auto ml-md-4"
            style="max-width: 700px"
          >
            <div class="input-group-prepend hide">
              <span
                class="input-group-text bg-primary2"
                id="docsSearch"
              >
                <span class="fas fa-search"></span>
              </span>
            </div>
            <input
              id="input_search"
              class="js-hs-docs-search hide form-control pl-0 ui-autocomplete-input"
              type="text"
              placeholder="Pesquisar..."
              style="height: 36px; padding-right: 5px"
              aria-label="Pesquisar..."
              aria-describedby="docsSearch"
            />
          </div>
          
          <div
            class="dropdown white_font"
            style="margin-right: 5px; user-select: none"
          >
            <a
              class="dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                :src="picture"
                class="img_avatar_small"
              />
            </a>
            <div
              class="dropdown-menu p-2 bg-light-grey"
              style="margin-left: -90px"
              aria-labelledby="dropdownMenuButton"
            >
              <inertia-link
                href="/recruiters/profile/edit"
                class="btn full mt-1 mb-1 btn-dark user-dropdown-item"
              >Perfil</inertia-link>
              <button
                @click="logout"
                class="btn full mt-1 mb-1 btn-dark user-dropdown-item"
              >
                Logout
              </button>
            </div>
          </div>
        </nav>
      </header>
      <div class="container-fluid">
        <div class="row">
          <div
            style="background-color: #241a3f"
            class="col-lg-1 col-md-1 col-xs-12 px-0"
          >
            <div class="pt-2 full_height">
              <MenuAdminItem
                label="Vagas"
                url="/recruiters/evaluators/jobs"
                img="/images/VAGA_ICON.png"
                img_active="/images/VAGA_COLOR_ICON.png"
                :active="menu"
              />
            </div>
          </div>
          <div
            :class="{
              'p-0': fullLayout(this.menu),
              galleries: this.menu == 'Galeria de vídeos' ? true : false,
              'p-4': !fullLayout(this.menu),
            }"
            :style="{ ...customStyle, ...contentStyles }"
            class="col-lg-11 col-md-11 col-xs-12"
          >

            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import MenuAdminItem from "components/MenuAdminItem.vue";
import { mutationsMap } from "store/business.js";

export default {
  props: ["menu", "customStyle"],
  components: { MenuAdminItem },
  data() {
    return {
      picture: "/images/avatar.png",
      windowHeight: window.innerWidth,
    };
  },
  mounted() {
    if (this.windowHeight >= 768) {
      document.body.classList.add("overflow-hidden");
    }
    axios.get("/recruiters/profile/info").then((response) => {
      if (response.data.extra_options) {
        mutationsMap.setExtraOptions(response.data.extra_options);
      }
    });
    localStorage.getItem("avatar-url")
      ? (this.picture = localStorage.getItem("avatar-url"))
      : false;
  },
  computed: {
    contentStyles() {
      let styles = {
        height: "90vh",
        overflow: "auto !important",
      };

      return this.windowHeight >= 768 ? styles : {};
    },
  },
  methods: {
    fullLayout(menu) {
      let screens = ["Galeria de vídeos"];

      if (screens.includes(menu)) return true;
      return false;
    },
    logout() {
      localStorage.removeItem("avatar-url");
      axios
        .delete("/recruiters/sign_out")
        .then((resource) => {
          window.location = "/";
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
